import { render } from "./ExpertProfileView.vue?vue&type=template&id=70f1fba1&scoped=true"
import script from "./ExpertProfileView.vue?vue&type=script&lang=js"
export * from "./ExpertProfileView.vue?vue&type=script&lang=js"

import "./ExpertProfileView.vue?vue&type=style&index=0&id=70f1fba1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f1fba1"]])

export default __exports__